
import { useEffect, useState } from "react";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./BookingManagement.module.css";
import TabBar from "components/tabBar/TabBar";
import BookingManagementTimeTable from "./BookingManagementTimeTable";
import BookingManagementBookingTable from "./BookingManagementBookingTable";
import BookingManagementCancelTable from "./BookingManagementCancelTable";
import { LuCalendarDays } from "react-icons/lu";
import { getEmployBookingCounter } from "services/booking/get-employ-booking-counter";


export default function EmployBookingManagement() {

  const [bookingCount, setBookingCount] = useState(0);
  const [cancelCount, setCancelCount] = useState(0);
  const tabs = [
    { id: "overview", label: "Übersicht" },
    { id: "orders", label: `Anfrage (${bookingCount})` },
    { id: "cancellations", label: `Stornierungen (${cancelCount})` },
  ];

  const [activeTab, setActiveTab] = useState<string>(tabs[0].id);
  const fetchData = async () => {
    try {
      const kidsBookingsCountData = await getEmployBookingCounter();
      setBookingCount(parseInt(kidsBookingsCountData.data.booking_counter, 10) || 0);
      setCancelCount(parseInt(kidsBookingsCountData.data.cancel_counter, 10) || 0);
    } catch (error) {
      console.error("Fehler beim Abrufen der daten:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <div className={styles.container}>
      <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
        <LuCalendarDays className={commonStyles.sectionTitleIcon} />
        <h1>Buchungsverwaltung</h1>
      </div>

      <TabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

      <div className={styles.tabContent}>
        {activeTab === "overview" && <BookingManagementTimeTable />}
        {activeTab === "orders" && <BookingManagementBookingTable />}
        {activeTab === "cancellations" && <BookingManagementCancelTable />}
      </div>
    </div>
  );
}
